//import { Route, Router, history } from 'react-router';
import { Link } from 'react-router-dom'
import React, { Component } from 'react'
import { withStore } from '../store'
import CloseUpSVG from '../../svg/CloseUpSVG'
import EditUpSVG from '../../svg/EditUpSVG'
import Table from '../Table'
import VolunteerUpSVG from '../../svg/VolunteerUpSVG'
import VeteranUpSVG from '../../svg/VeteranUpSVG'
import Loader from '../Loader'
import { Service } from '../ApiService'
import FixedWrapper from '../FixedWrapper'
import MultiDropDown from '../MultiDropDown/MultiDropDown'
import CheckBox from '../CheckBox'
import SearchInput from '../SearchInput'
import Alert from '../Alert'
import { Helper } from '../Helper'

import TabComponent from '../TabComponent';

class EventServices extends Component {
    static displayName = EventServices.name;

    constructor(props) {
        super(props);
        this.state = {
            eventId: props.eventId,
            eventServiceLines: [],
            serviceList: [],
            loading: false,
            addingService: false,
            editingService: false,
            serviceToEdit: null,
            tempServices: [],
            filteredList: [],
            selectAllCheckboxChecked: false,
            selectedServicesOnlyChecked: false,
            serviceFilter: '',
        };
        this.substractHeightElRef = null;
        this.modalWindowRef = null;
        this.membersDropDownRef = null;
        this.filterTimeout = null;
        this.removeService = this.removeService.bind(this);
        this.addService = this.addService.bind(this);
        this.submitServicesToEvent = this.submitServicesToEvent.bind(this);
        this.filterServiceList = this.filterServiceList.bind(this);
    }

    submitServicesToEvent() {
        this.setState({ loading: true });
        var linesToAdd = [];
        this.state.tempServices.map((value) => {
            var serviceLine = this.state.serviceList.find(sl => sl.serviceLineId === value);
            linesToAdd.push({
                servicePriceType: 0,
                price: serviceLine.oneTimePrice,
                gracePrice: serviceLine.oneTimeGracePrice,
                calendarEventId: this.state.eventId,
                serviceId: value
            });
        });
        Service.addEventServices(linesToAdd)
            .then(data => {
                console.log(data);
                this.setState({
                    eventServiceLines: data,
                    tempServices: [],
                    loading: false,
                    addingService: false,
                    serviceFilter: ''
                })
            });
    }

    editServiceLine = () => {
        this.setState({ loading: true }, () => {
            var modelLine = this.state.serviceToEdit;
            let serviceLine = this.state.eventServiceLines.find(x => x.eventServiceLineId === modelLine.eventServiceLineId);
            serviceLine.price = modelLine.price;
            serviceLine.gracePrice = modelLine.gracePrice;
            serviceLine.servicePriceType = modelLine.servicePriceType;
            var thenFunc = (data) => this.setState({ loading: false, editingService: false, serviceToEdit: null });
            Service.updateEventService(this.state.eventId, serviceLine)
                .then(thenFunc);
        });
    }

    componentDidMount() {
        this.setState({ loading: true });
        Service.getEventSelectedServices(this.state.eventId)
            .then(data => this.setState({ eventServiceLines: data, loading: false }));
    }

    addService = () => {
        this.setState({ loading: true });

        Service.getServiceList()
            .then(data => {
                this.setState({
                    serviceList: data,
                    loading: false,
                    addingService: true
                }, () => this.filterServiceList(this.state.serviceList, this.state.serviceFilter))
            });


        //Service.getServiceList()
        //    .then(data => {
        //        this.setState({
        //            serviceList: data,
        //            loading: false,
        //            addingService: true
        //        }, () => this.filterServiceList(this.state.serviceList, this.state.serviceFilter))
        //    });

        //Service.getSiteMembers(this.state.eventId)
        //    .then(data => { this.setState({ 
        //        siteMembers: data, 
        //        loading: false, 
        //        addingService: true
        //    }, () => this.filterMemberList(this.state.serviceList, this.state.attendeeFilter)) });
    }

    removeService = (service) => {
        var me = this;
        this.setState({ loading: true })
        Service.deleteEventService(service.eventServiceLineId)
            .then(data => {
                setTimeout(() => {
                    me.setState({ eventServiceLines: data, loading: false });
                }, 1000);
            });
    }

    createFilteredListWithTimeOut() {
        this.timeoutVar = setTimeout(() => { this.filterServiceList(this.state.serviceList, this.state.serviceFilter) }, 150);
    }

    filterServiceList = (list, filter) => {
        /* check if element meets criteria */
        let checkIfElementMeetsCriteria = (el, filterList) => {
            let meetsCriteria = true;
            filterList.forEach(elFilter => {
                if (!(el.name.toLowerCase().includes(elFilter) || el.description.toLowerCase().includes(elFilter) || el.oneTimePrice == elFilter || el.dailyPrice == elFilter)) {
                    meetsCriteria = false;
                }
            })
            return meetsCriteria;
        }
        /* remove all " " at the beginning and double ' ' inside the filter expression if they are there */
        filter = filter.replace(/\,+/g, ' ');
        filter = filter.toLowerCase().replace(/\s+/g, ' ');
        /* create an array of filters*/
        let filterList = [];
        if (filter !== '') { filterList = filter.split(" ") }
        else filterList = filter;
        /* filter */
        let filteredList = [];
        var selectedServicesOnlyChecked = this.state.selectedServicesOnlyChecked;
        list.forEach(element => {
            if (((filterList.length > 0 && checkIfElementMeetsCriteria(element, filterList)) || filterList === '') &&
                (this.state.selectedServicesOnlyChecked === false || (
                    this.state.selectedServicesOnlyChecked === true && this.state.tempServices.indexOf(element.serviceLineId) > -1))
            ) { filteredList.push(element) }
        })
        this.setState({ filteredList: filteredList })
    }

    renderServiceName = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <span style={{ "flex": "1 1 auto" }} className="big-bold">{row.service.name}</span>
                {this.props.editsPermitted !== false &&
                    <button
                        className='round-button small-round-button light-grey-outline-button'
                        style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                        onClick={() => {
                            this.headerText = 'Warning';
                            this.dialogText = 'You want to remove the Service'
                            this.onOkButtonClick = () => { this.removeService(row); this.setState({ showDialog: false }) };
                            this.cancelButtonText = 'Cancel';
                            this.okButtonText = 'Remove';
                            this.dialogContent = <h4>{row.service.name}</h4>
                            this.setState({ showDialog: true })/*this.removeMember(row)*/
                        }}
                    >
                        <CloseUpSVG />
                    </button>
                }
                {this.props.editsPermitted !== false &&
                    <button
                        className='round-button small-round-button light-grey-outline-button'
                        style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                        onClick={() => {
                            this.setState({ editingService: true, serviceToEdit: row })
                        }}
                    >
                        <EditUpSVG />
                    </button>
                    //<Link
                    //    className='round-button small-round-button light-grey-outline-button'
                    //    style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                    //    to={"/service/" + row.id}
                    //>
                    //    <EditUpSVG />
                    //</Link>
                }
            </li>
        );
    }

    renderServiceDescription = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <span className='description-text'>{row.service.description}</span>
            </li>
        );
    }

    renderPrice = (value, row, index, col) => {
        return (
            <li key={index} className='table-content-vertical'>
                <div className={col.className ? col.className : ''} style={{ display: 'flex' }}>
                    <span className='mr-05 bold-text'>{Helper.CurrencyFormat(row.price, true)}</span>
                </div>
                {row.gracePrice > 0 && this.props.gracePricePeriod > 0 &&
                    <div className={col.className ? col.className : ''} style={{ display: 'flex' }}>
                        <span className='mr-05 bold-text'>{Helper.CurrencyFormat(row.gracePrice, true)}</span>
                    <span>Pay period > {this.props.gracePricePeriod}</span>
                    </div>
                }
            </li>
        )
    }

    textPropertyGroupRender(element, textProperty) {
        var serviceGroupName = this.props.store.serviceGroups.find(group => group.id == element['serviceGroup']).name;
        return <span className='group'>{serviceGroupName}</span>
    }

    textPropertyContentRender(element, textProperty) {
        return <div className='mb-075'>
            <span className='name mb-025'>{element["name"]}</span>
            <span className='description-text label-input-wrapper mb-025'>{element["description"]}</span>
            {/*</div>
            <div style={{ flex: '1 0 auto' }}>*/}
            {element["oneTimePrice"] && element["oneTimePrice"] != 0 ? <span className='mb-025'>One time charge: {<strong>{Helper.CurrencyFormat(element["oneTimePrice"])}</strong>}</span> : ''}
            {element["dailyPrice"] && element["dailyPrice"] != 0 ? <span className='mb-025'>Daily charge: {<strong>{Helper.CurrencyFormat(element["dailyPrice"])}</strong>}</span> : ''}
        </div>
    }

    textPropertyRender(element, textProperty) {
        var serviceGroupName = this.props.store.serviceGroups.find(group => group.id == element['serviceGroup']).name;
        return <div style={{ display: 'flex' }}>
            <div style={{ flex: '1 1 auto' }}>
                <span className='group'>{serviceGroupName}</span>
                <span className='name'>{element["name"]}</span>
                <span className='description-text label-input-wrapper'>{element["description"]}</span>
                {/*</div>
            <div style={{ flex: '1 0 auto' }}>*/}
                <span>One time charge: {<strong>{Helper.CurrencyFormat(element["oneTimePrice"])}</strong>}</span>
                {element["dailyPrice"] && element["dailyPrice"] != 0 ? <span>Daily charge: {<strong>{Helper.CurrencyFormat(element["dailyPrice"])}</strong>}</span> : ''}
            </div>
        </div>
    }

    updateServiceLine = (valueList) => {
        let serviceToEdit = this.state.serviceToEdit;
        valueList.forEach(pair => {
            serviceToEdit[pair.property] = pair.value;
        });
        this.setState({ serviceToEdit: serviceToEdit })
    }


    onAddServiceWindowClose() {
        this.setState({ addingService: false, serviceFilter: '' })
    }

    getPanelToRender = () => {
        if (this.state.addingService) {
            return this.getAddServicePanel();
        }
        else if (this.state.editingService) {
            return this.getEditServicesPanel();
        }
        else {
            return this.getMainEventServicesPanel()
        }
    }

    getAddServicePanel = () => {
        return <FixedWrapper maxWidth={"600px"} noPadding={true}>
            <h2 className='ml-075 mr-075 mt-2 mb-1'>Add Services</h2>
            <SearchInput
                placeholder='Search services'
                wrapperClassName='m-075'
                value={this.state.serviceFilter}
                onValueChange={(value) => {
                    clearTimeout(this.timeoutVar);
                    this.setState({ serviceFilter: value }, this.createFilteredListWithTimeOut());
                }}
                onClearValueButtonClick={() => {
                    clearTimeout(this.timeoutVar);
                    this.setState({ serviceFilter: "" }, this.createFilteredListWithTimeOut());
                }}
            />
            <div className='flex-wrap justify-space-between align-center mr-075 ml-05 mb-05'>
                <CheckBox
                    className='mr-1 mb-1 ml-025'
                    onClick={() => {
                        clearTimeout(this.timeoutVar); // ????
                        let services = [];
                        if (!this.state.selectAllCheckboxChecked) {
                            this.state.filteredList.forEach(element => {
                                services.push(element.serviceLineId)
                            })
                        }
                        this.setState({
                            tempServices: services,
                            selectAllCheckboxChecked: !this.state.selectAllCheckboxChecked
                        }, this.createFilteredListWithTimeOut());
                    }}
                    checked={this.state.selectAllCheckboxChecked}
                    labelStyle={{ "fontSize": "0.9rem" }}
                    labelText={<span>Select All<strong>{" " + this.state.filteredList.length.toString()}</strong></span>}
                />
                <div className='flex-wrap justify-left'>
                    <CheckBox
                        className='mb-1 ml-025'
                        onClick={() => {
                            clearTimeout(this.timeoutVar);
                            this.setState({
                                selectedServicesOnlyChecked: !this.state.selectedServicesOnlyChecked
                            }, this.createFilteredListWithTimeOut())
                        }}
                        checked={this.state.selectedServicesOnlyChecked}
                        labelStyle={{ "fontSize": "0.9rem" }}
                        labelText={<span>Selected Only<strong>{" " + this.state.tempServices.length.toString()}</strong></span>}
                    />
                </div>
            </div>
            {this.state.filteredList.length === 0 && <p className='message-block mb-2 mt-2'>There are no services that meet this criteria.</p>}
            {this.state.filteredList.length > 0 &&
                <MultiDropDown
                    className='pr-075'
                    customHeightCoeff={1.5}
                    list={this.state.filteredList}
                    multiSelect={true}
                    toggleable={false}
                    keyProperty='serviceLineId'
                    textProperty='name'
                    defaultValue={this.state.tempServices}
                    placeholder="Select from the list"
                    onDropDownValueChange={value => this.setState({ tempServices: value })}
                    hideHeader={true}
                    substractHeight={65}
                    textPropertyRender={(element, textProperty) => this.textPropertyRender(element, textProperty)}
                />

            }
            <div className='flex-nowrap justify-center mt-1 mb-05 mr-075 ml-075'>
                <button ref={el => this.okButtonRef = el} className='medium-static-button static-button' onClick={this.submitServicesToEvent}>OK</button>
                <button ref={el => this.cancelButtonRef = el} className='medium-static-button static-button default-button' onClick={() => this.setState({ addingService: false, tempServices: [], serviceFilter: '' })}>Cancel</button>
            </div>
        </FixedWrapper>
    }

    getEditServicesPanel = () => {
        let serviceToEdit = this.state.serviceToEdit;
        return <FixedWrapper maxWidth={"600px"}>
            <h2 className='mt-3 mr-05 ml-05 mb-1'>Edit Service</h2>
            <ul className='input-fields first-child-text-145 mt-1'>
                <li>
                    <p>Service:</p>
                    <p className='label word-break'>{serviceToEdit.service.name}</p>
                </li>
                <li>
                    <p />
                    <p className='description-text word-break'>{serviceToEdit.service.description}</p>
                </li>
                <li>
                    <p>Standard Price:</p>
                    <div className='input-button-wrapper currency-input-wrapper'>
                        <input type='number'
                            value={serviceToEdit.price > 0 ? serviceToEdit.price : ""}
                            onChange={(e) => {
                                this.emptyName = false;
                                let price = Math.floor(e.target.value * 100) / 100;
                                this.updateServiceLine([{ property: 'price', value: price }]);

                            }}
                        />
                        {serviceToEdit.price > 0 &&
                            <button onClick={() => this.updateServiceLine([{ property: 'price', value: 0 }])}>
                                <CloseUpSVG />
                            </button>
                        }
                    </div>
                </li>
                <li>
                    <p>Advance Pmt Price:</p>
                    <div className='input-button-wrapper currency-input-wrapper'>
                        <input type='number'
                            value={serviceToEdit.price > 0 ? serviceToEdit.gracePrice : ""}
                            onChange={(e) => {
                                this.emptyName = false;
                                let price = Math.floor(e.target.value * 100) / 100;
                                this.updateServiceLine([{ property: 'gracePrice', value: price }]);

                            }}
                        />
                        {serviceToEdit.gracePrice > 0 &&
                            <button onClick={() => this.updateServiceLine([{ property: 'gracePrice', value: 0 }])}>
                                <CloseUpSVG />
                            </button>
                        }
                    </div>
                </li>
            </ul>
            <div className='flex-nowrap justify-center mt-2 mb-1 mr-1 ml-1'>
                <button
                    //ref = {el => this.okButtonRef = el}
                    className='medium-static-button static-button'
                    onClick={() => { this.editServiceLine() }}
                > Save </button>
                <button
                    /*ref = {el => this.cancelButtonRef = el} */
                    className='medium-static-button static-button default-button'
                    onClick={() => this.setState({ editingService: false, serviceToEdit: null })}
                > Cancel </button>
            </div>
        </FixedWrapper>
    }

    getMainEventServicesPanel = () => {
        const eventServiceLines = this.state.eventServiceLines;

        const columns = [
            { title: "Service", accesor: "name", className: "borders-when-display-block", render: this.renderServiceName },
            { title: "", accesor: "description", className: "borders-when-display-block", render: this.renderServiceDescription },
            { title: "Price", accesor: "oneTimePrice", render: this.renderPrice },
        ];

        return <div>
            {eventServiceLines.length === 0 && <p className='message-block mb-2 pr-1 pl-1'>There are no services registered for the event.</p>}
            {this.props.editsPermitted !== false &&
                <div className="flex-wrap align-center justify-center mb-2 pr-1 pl-1">
                    <p className='input-label'>ADD SERVICE:</p>
                    <span>
                        <button className='big-static-button static-button' onClick={this.addService}>Add Services</button>
                    </span>
                </div>
            }
            {eventServiceLines.length > 0 && <Table
                groupProperty='serviceGroup'
                groupRendeder={(group) => {
                    var rec = this.props.store.serviceGroups.find(e => e.id == group);
                    if (rec) return rec.name;
                    return '';
                }}
                columns={columns}
                data={eventServiceLines}
                className={"break-at-500"}
                addHeadersForNarrowScreen={true} />}
        </div>
    }

    render() {
        var panel = this.getPanelToRender();
        return (
            <div className='w-100 prpl-0'>
                {this.state.loading && <Loader />}

                {panel}

                {this.state.showDialog && 
                    <Alert 
                        headerText = {this.headerText}
                        text = {this.dialogText}
                        onClose = {() => this.setState({showDialog: false})}
                        showOkCancelButtons = {true}
                        onCancelButtonClick = {() => this.setState({showDialog: false})}
                        onOkButtonClick = {this.onOkButtonClick}
                        cancelButtonText = {this.cancelButtonText}
                        okButtonText = {this.okButtonText}
                        mode = 'warning'
                    >
                       {this.dialogContent}
                    </Alert>
                }
            </div>
        );
    }
}

export default withStore(EventServices)



// WEBPACK FOOTER //
// ./src/components/event/EventServices.jsx